// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("grid"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.desktop, [
            BsCssJs$PrezzeeRibbon.gridTemplateColumns([
                  BsCssJs$PrezzeeRibbon.fr(2),
                  {
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(453),
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }
                ]),
            BsCssJs$PrezzeeRibbon.gridTemplateRows([{
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(400),
                      "maxContent"
                    ]
                  }]),
            BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(9))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tabletOrMobile, [
            BsCssJs$PrezzeeRibbon.gridTemplateColumns([BsCssJs$PrezzeeRibbon.pct(100)]),
            BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.px(10))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tablet, [BsCssJs$PrezzeeRibbon.gridTemplateRows([
                  {
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(400),
                      "maxContent"
                    ]
                  },
                  {
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(265),
                      "maxContent"
                    ]
                  }
                ])])
    ]);

var leftPanel = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.display("flex")]);

var rightPanel = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.display("flex")]);

var Styles = {
  wrapper: wrapper,
  leftPanel: leftPanel,
  rightPanel: rightPanel
};

function TwoOneHeroTiles(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.leftTile,
                      className: leftPanel
                    }),
                JsxRuntime.jsx("div", {
                      children: props.rightTile,
                      className: rightPanel
                    })
              ],
              className: wrapper
            });
}

var make = TwoOneHeroTiles;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
